export default __webpack_public_path__ + "static/media/94hive-logo.b92846f7.png";